import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ContactUsButton from '@sputnik/components/ContactUsButton'
import ImageWrapper from '@sputnik/components/ImageWrapper'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

import styles from './styles.module.scss'

const MaintenanceScreen = () => {
  const [getClassName, makeTestId] = useNameFormatter('MaintenanceScreen')

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <div className={styles[getClassName('road-barricade-img')]}>
        <ImageWrapper
          alt='road-barricade'
          dataTestId={makeTestId('img')}
          imageName='road-barricade'
        />
      </div>
      <div
        className={styles[getClassName('heading')]}
        data-testid={makeTestId('heading')}
      >
        <FormattedMessage
          defaultMessage="We'll be back soon"
          id='sputnik.MaintenanceScreen__GM4TRa'
        />
      </div>
      <div
        className={styles[getClassName('sub-heading')]}
        data-testid={makeTestId('sub-heading')}
      >
        <FormattedMessage
          defaultMessage="We're working on making the {BILL_SPEND_AND_EXPENSE} application better for our customers. Please check back later to access your application."
          id='sputnik.MaintenanceScreen__QQRA1N'
          values={{ BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE }}
        />
      </div>
      <div className={styles[getClassName('sub-heading')]}>
        <FormattedMessage
          defaultMessage='Thanks for your patience.'
          id='sputnik.MaintenanceScreen__hYQpHO'
        />
      </div>
      <div
        className={styles[getClassName('cta-container')]}
        data-testid={makeTestId('cta-conatiner')}
      >
        <ContactUsButton />
      </div>
    </div>
  )
}

export default MaintenanceScreen
